enum BusinessType {
    INDIVIDUAL = 'individual',
    SOLE_PROPRIETOR = 'sole-proprietor',
    SINGLE_MEMBER_LLC = 'single-member-llc',
    OTHER_ENTITY = 'other-entity'
}

export default BusinessType;
